import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { auth } from '@/services/auth';

/**
 * Wraps every route. However the person signs out — the sidebar, a refusal
 * screen, another tab — the sign-in page comes up and their data leaves the
 * cache.
 */
export function FollowSignOut() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const onSignIn = useLocation().pathname === '/sign-in';

  useEffect(
    () =>
      auth.subscribe((signedIn) => {
        if (!signedIn) {
          void navigate('/sign-in', { replace: true });
        }
      }),
    [navigate],
  );

  // Cleared only once the sign-in page is on screen. `navigate` resolves
  // before React shows the new page, and a screen still mounted over an empty
  // cache asks the API again, signed out.
  useEffect(() => {
    if (onSignIn) {
      queryClient.clear();
    }
  }, [onSignIn, queryClient]);

  return <Outlet />;
}
